// extracted by mini-css-extract-plugin
export var author = "index-module--author--epoZJ";
export var authorBio = "index-module--authorBio--PuB4J";
export var authorImg = "index-module--authorImg--jg8yH";
export var authorMeta = "index-module--authorMeta--x0Nrh";
export var authorMetaBottom = "index-module--authorMetaBottom--boGxs";
export var authorMetaName = "index-module--authorMetaName--21bdg";
export var authorMetaTitle = "index-module--authorMetaTitle--HZKu2";
export var authorMetaTop = "index-module--authorMetaTop--Tj+fT";
export var backLink = "index-module--backLink--Iir5h";
export var blackCircle = "index-module--blackCircle--KUsQJ";
export var content = "index-module--content--CSrk4";
export var date = "index-module--date--E5cYh";
export var defaultImageContainer = "index-module--defaultImageContainer--xHI6i";
export var defaultImageInnerContainer = "index-module--defaultImageInnerContainer--1fpB+";
export var hero = "index-module--hero--a55WI";
export var inlineGatsbyImageWrapper = "index-module--inline-gatsby-image-wrapper--bw2G8";
export var innerAuthor = "index-module--innerAuthor--TimcP";
export var leftArrow = "index-module--leftArrow--Siy7b";
export var ousterTagDetail = "index-module--ousterTagDetail--Wqch-";
export var previewCardContainer = "index-module--previewCardContainer--aFxv+";
export var tagName = "index-module--tagName--X6Y8u";
export var title = "index-module--title--2Fc0G";
export var wrapper = "index-module--wrapper--lHVGg";